module.exports = __webpack_public_path__ + "img/nav-user.80b9b937.svg";